import { html, LitElement } from 'lit';
import { getAgo, secondsToTimestamp } from 'Utils/text';

import Styles from './vm-kol-profile-page-video-list-item.scss';

export default class VmKolProfilePageVideoListItem extends LitElement {
    static styles = Styles;

    static properties = {
        video: { type: Object },
    };

    constructor() {
        super();
        this.video = null;
    }

    renderContributorsMarkup(contributor) {
        return html`<a href="/accounts/${contributor.uuid}/">${contributor.first_name} ${contributor.last_name}</a>`;
    }

    authorLink() {
        if (this.video.channel?.slug) {
            return `/channel/${this.video.channel.slug}/`;
        }
        return `/accounts/${this.video.author.uuid}/`;
    }

    authorLinkTitle() {
        if (this.video.channel?.title) {
            return this.video.channel.title;
        }
        return `${this.video.author.first_name} ${this.video.author.last_name}`;
    }

    render() {
        if (!this.video) return html``;

        return html`
            <div class="video-item">
                <div class="video-item__img-container">
                    <a href="/video/${this.video.slug}/">
                        <img src="${this.video.thumbnail_large}" class="video-item__img" />
                        <span class="video-item__duration">
                            ${secondsToTimestamp(Math.floor(this.video.duration / 1000))}
                        </span>
                    </a>
                </div>
                <div class="video-item__info">
                    <h3 class="video-item__author">
                        <a href="${this.authorLink()}" title="${this.authorLinkTitle()}">
                            ${this.video.author.first_name} ${this.video.author.last_name}
                        </a>
                    </h3>
                    <h2 class="video-item__title">
                        <a href="/video/${this.video.slug}/"> ${this.video.title} </a>
                    </h2>
                    <div class="video-item__contributors">
                        ${this.video.contributors.map(
                            (c, index) => html`
                                ${this.renderContributorsMarkup(c)}
                                ${index < this.video.contributors.length - 1 ? html`,&nbsp;` : ''}
                            `,
                        )}
                    </div>
                    <div class="video-item__meta">
                        <p>${getAgo(this.video.created)}</p>
                        <span>·</span>
                        <p>${this.video.views}</p>
                    </div>
                </div>
            </div>
        `;
    }
}
